<div
  #chart
  [style.width.px]="width"
  [style.height.px]="height"></div>
